import { render } from "./PostNavBtn.vue?vue&type=template&id=755b9e4a&scoped=true"
import script from "./PostNavBtn.vue?vue&type=script&lang=js"
export * from "./PostNavBtn.vue?vue&type=script&lang=js"

import "./PostNavBtn.vue?vue&type=style&index=0&id=755b9e4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-755b9e4a"]])

export default __exports__